var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_7)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75726 4.2224C10.4451 4.21711 11.0014 4.77129 11 5.46054C10.9984 6.14961 10.4396 6.71249 9.75189 6.71787L6.73563 6.73894L6.71459 9.76411C6.70895 10.4474 6.1472 11.0008 5.46003 11C4.77268 10.9991 4.22033 10.4442 4.22597 9.7607L4.24683 6.75643L1.24266 6.77751C0.555038 6.78289 -0.00142959 6.22862 2.75896e-06 5.53946C0.00161415 4.85039 0.560499 4.28751 1.24821 4.28222L4.26438 4.26106L4.2855 1.2359C4.29123 0.552566 4.85289 -0.000806306 5.54006 8.81944e-07C6.22741 0.00080807 6.77976 0.555795 6.77403 1.2393L6.75317 4.24357L9.75726 4.2224Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.909b1d038e2b5da6df72cd0933369fb4.svg";
export { ForwardRef as ReactComponent };